var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('search_list')))])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('api-table',{attrs:{"entity":"Search","route":"search","path":"search","filterable":_vm.filterable,"columns":_vm.columns,"templates":_vm.templates}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57751b9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 752
// module chunks = 0